import { TemplateCta, TemplateFooter, TemplateMeta } from './TemplateParts';

export default function DigitalInviteAurea({ data }) {
  const {
    artTypeLabel,
    coupleName,
    rows,
    shortPhrase,
    ctaText,
    showSiteLink,
    siteUrl,
    showQrCode,
    textColor,
    textShadow,
    accentColor,
    titleStyle,
    bodyStyle,
    isPremium
  } = data;

  return (
    <div className="absolute inset-0">
      <div className="absolute inset-0 bg-gradient-to-r from-[#1A1118]/54 via-[#1A1118]/18 to-transparent" />
      <div className="absolute inset-y-0 right-0 w-[58%] bg-gradient-to-b from-[#130D11]/30 via-[#181017]/68 to-[#10090E]/92" />
      <div className="absolute inset-y-0 right-[58%] w-px bg-white/22" />
      <div className="absolute inset-y-0 right-[58%] translate-x-[12px] w-px bg-[#D2AA7C]/58" />

      <div className="absolute inset-0 p-5 md:p-6 flex">
        <div className="ml-auto w-full max-w-[64%] h-full rounded-[18px] border border-white/20 bg-black/26 shadow-[0_24px_44px_rgba(0,0,0,0.38)] backdrop-blur-[1.3px] p-5 md:p-6 flex flex-col">
          <div className="flex items-center justify-between text-white/92">
            <span className="rounded-full px-3 py-1 text-[10px] uppercase tracking-[0.16em] font-semibold bg-white/10 border border-white/18">
              {artTypeLabel}
            </span>
            {isPremium && (
              <span className="rounded-full px-3 py-1 text-[10px] uppercase tracking-[0.14em] font-semibold bg-[#FFF4E5] text-[#9C784C]">
                Premium
              </span>
            )}
          </div>

          <div className="mt-auto">
            <h4 className="text-[2.35rem] md:text-[3.2rem] font-bold leading-[1.01]" style={titleStyle}>
              {coupleName}
            </h4>
            <div className="mt-4">
              <TemplateMeta rows={rows} textColor={textColor} textShadow={textShadow} family={bodyStyle.metaFamily} tracking={bodyStyle.metaTracking} />
            </div>
            {shortPhrase ? (
              <p className="mt-5 text-sm md:text-base max-w-[95%]" style={bodyStyle.style}>
                {shortPhrase}
              </p>
            ) : null}
          </div>

          {ctaText ? (
            <div className="mt-4">
              <TemplateCta text={ctaText} textColor={textColor} textShadow={textShadow} mode="line_label" />
            </div>
          ) : null}

          <TemplateFooter
            showSiteLink={showSiteLink}
            siteUrl={siteUrl}
            showQrCode={showQrCode}
            textColor={textColor}
            accentColor={accentColor}
            darkSurface
          />
        </div>
      </div>
    </div>
  );
}
